module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    ref: "Form",
    attrs: {
      "model": _vm.Form,
      "label-position": _vm.labelPosition,
      "rules": _vm.FormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "队伍中文全称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.Name),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Name", $$v)
      },
      expression: "Form.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "队伍中文简称",
      "prop": "ShortName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.ShortName),
      callback: function($$v) {
        _vm.$set(_vm.Form, "ShortName", $$v)
      },
      expression: "Form.ShortName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "首字母简称",
      "prop": "PhoneticName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.PhoneticName),
      callback: function($$v) {
        _vm.$set(_vm.Form, "PhoneticName", $$v)
      },
      expression: "Form.PhoneticName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "国籍",
      "prop": "Citizenship"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.Citizenship),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Citizenship", $$v)
      },
      expression: "Form.Citizenship"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区号",
      "prop": "AreaCode"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.AreaCode),
      callback: function($$v) {
        _vm.$set(_vm.Form, "AreaCode", $$v)
      },
      expression: "Form.AreaCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "队伍类型",
      "prop": "TeamType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择队伍类型"
    },
    model: {
      value: (_vm.Form.TeamType),
      callback: function($$v) {
        _vm.$set(_vm.Form, "TeamType", $$v)
      },
      expression: "Form.TeamType"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票单位名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.Unit),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Unit", $$v)
      },
      expression: "Form.Unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "税号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.TaxNumber),
      callback: function($$v) {
        _vm.$set(_vm.Form, "TaxNumber", $$v)
      },
      expression: "Form.TaxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.Form.Remark),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Remark", $$v)
      },
      expression: "Form.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98fb7c3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Competition/Team.vue
// module id = 1396
// module chunks = 1